var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$userInfo
      ? _c("div", { staticClass: "tile is-parent" }, [
          _c("article", { staticClass: "tile is-child box" }, [
            _vm._m(0),
            _c("div", { staticClass: "field-body is-justify-content-center" }, [
              _vm.innerValue
                ? _c("div", { staticClass: "box" }, [
                    _c("div", { staticClass: "columns is-multiline" }, [
                      _c("div", { staticClass: "column is-6" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Event ID"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.innerValue.eventId || "N/A")),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-6" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Created Date"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDate(_vm.innerValue.createdDate)
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-6" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Company"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.innerValue.company || "N/A")),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-6" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("User"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.innerValue.user || "N/A")),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-full" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Page URL"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("span", { staticClass: "url-text" }, [
                              _vm._v(_vm._s(_vm.innerValue.pageUrl || "N/A")),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-full" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Call Site"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("span", { staticClass: "url-text" }, [
                              _vm._v(
                                _vm._s(_vm.innerValue.referrerUrl || "N/A")
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-full" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Message"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("div", { staticClass: "message-text" }, [
                              _vm._v(_vm._s(_vm.innerValue.message || "N/A")),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-full" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Exception"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("div", { staticClass: "json-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.parsedMessage.innerException ||
                                    _vm.parsedMessage.exception
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "column is-full" }, [
                        _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Stack Trace"),
                          ]),
                          _c("div", { staticClass: "control" }, [
                            _c("div", { staticClass: "json-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.parsedMessage.innerStackTrace ||
                                    _vm.parsedMessage.stackTrace
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ])
                : _c("div", { staticClass: "box" }, [_vm._m(1)]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "columns is-flex is-align-items-center" }, [
      _c("div", { staticClass: "column" }, [
        _c("p", { staticClass: "title" }, [_vm._v("Error Log Detail")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "section" }, [
      _c("div", { staticClass: "content has-text-grey has-text-centered" }, [
        _c("span", { attrs: { icon: "icon is-large" } }, [
          _c("span", { staticClass: "mso mso-fill mso-40px" }, [
            _vm._v("sentiment_dissatisfied"),
          ]),
        ]),
        _c("p", [_vm._v("Nothing")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }